import React from "react";
import DynamicBreadcrumb from "../components/DynamicBreadcrumb"; 
import '../assets/css/footer.css';

export const FooterMobile = () => {
    const element = (
    <>
        {/* Mobile View */}
        <div className="mobile-footer container-fluid bg-color-blue-2 text-white d-xl-none">

            <div className="col-12 px-0">
                {/* <div className="col-12">
                        <DynamicBreadcrumb /> 
                    </div> */}
                <ul className="footer-links">
                    <li>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.k12.com/terms-of-use/">
                            Terms
                        </a>
                    </li>
                    <li>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.stridelearning.com/privacy-policy/">
                            Privacy
                        </a>
                    </li>
                    <li>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.k12.com/ip-policy/">
                            Copyright
                        </a>
                    </li>
                    <li>
                        <a target="_blank" rel="noopener noreferrer" href="https://www.k12.com/accessibility/">
                            Accessibility
                        </a>
                    </li>
                </ul>
                <div className="copyright">
                Copyright &copy; 2025 Stride, Inc. All rights reserved.
                </div>
            </div>

        </div>
    </> 

    )
    return element; 
}